import React, { Fragment } from 'react'
import { Breadcrumb, Card, Col, Popconfirm, Row, Tabs } from 'antd'
import style from '../../../../../components/Sales/style.css'
import { idMaker, strVal } from '../../../../../modules/Utils'
import Status from '../../../../../elements/Status'
import RefreshButton from '../../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../../elements/CustomSpin'
import FooterButtons from '../../../../../elements/Buttons/FooterButtons'
import CodeIcon from '../../../../../elements/CodeIcon'
import DWGForm from '../../../../../components/Operations/Engineering/DWG/DWGForm'
import Documents from '../../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../../components/Common/History'
import EmailCont from '../../../../../components/Common/Email/EmailCont'

const ids = idMaker()

function AddDWG (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    dwg,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    isConfirmed,
    isIssued,
    onShowEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
  } = props

  const isNew = type === 'new'
  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )
  const Operations = ({ dwg, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Operations</Breadcrumb.Item>
            <Breadcrumb.Item>Engineering</Breadcrumb.Item>
            <Breadcrumb.Item href={'#/operations/engineering/dwg'}>Technical Drawings</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New QA' : dwg.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Technical Drawing</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(dwg, 'code')} title={'QA Code'}/>
                  <Status value={strVal(dwg, 'status')}/>
                  <Operations style={{ marginTop: '10px' }} dwg={dwg} status={strVal(dwg, 'status')}/>
                </h3>
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <DWGForm ref={formRef} {...props} />
            {isUpdatable && <SubmitButton/>}
          </Tabs.TabPane>
          {/*<Tabs.TabPane disabled={type !== 'edit'} tab={'Lines'} key="#lines">
            <DWGLinesCont dwg={dwg} isUpdatable={isUpdatable} />
          </Tabs.TabPane>*/}
          {/*<Tabs.TabPane
            disabled={type !== 'edit'}
            tab={'Vendor Quotes'}
            key="#vendor-quotes">
            <VendorQuotesList
              vendorID={get(dwg, 'vendor._id')}
              dwgID={dwg._id}
              fetching={fetchingVendorQuotes}
              fetch={fetchVendorQuotes}
              list={listVendorQuotes}
              hideCompany={true}
            />
          </Tabs.TabPane>*/}

          <Tabs.TabPane disabled={type !== 'edit'} tab="Files" key="files">
            <Documents key={dwg._rev} editable={true} footer={false} category={false} email={true} owner={dwg}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={dwg} key={dwg._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddDWG
